export const datesAreOnSameDay = (a: Date, b: Date) =>
  datesAreInSameYear(a, b) &&
  datesAreInSameMonth(a, b) &&
  a.getDate() === b.getDate();

export const datesAreInSameMonth = (a: Date, b: Date) =>
  datesAreInSameYear(a, b) && a.getMonth() === b.getMonth();

export const datesAreInSameYear = (a: Date, b: Date) =>
  a.getFullYear() === b.getFullYear();

export const dateInPast = (date: Date) => {
  const now = new Date();
  return date < now;
};

export const dateInFuture = (date: Date) => {
  const now = new Date();
  return date > now;
};
